//* 메뉴 관련 API
import * as BaseApi from "api/Base.api";
const BASE_URL = "/student/v2/menu";

//* 메뉴에 필요한 모든 카운트 정보 요청
//  2025. 09. 16
//  희문
export interface IMenuCountInfoResponse {
    messageRequestCount: number;
    // newNoticeCount: number;
    notReadMessageCount: number;
    newCastingLogCount: number;
    newMagazineCount: number;
    todayDiaryCount: number;
}
export const fetchMenuCountInfo = async () => {
    const url = `${BASE_URL}`;
    return await BaseApi.get(url) as IMenuCountInfoResponse;
};

export interface IMessageRequestCountResponse {
    messageRequestCount: number;
}
//* 채팅 요청 수 조회
export const fetchMessageRequestCount = async () => {
    const url = `${BASE_URL}/message-request-count`;
    return await BaseApi.get(url) as IMessageRequestCountResponse;
};

export interface fetchNotReadMessageCountResponse {
    notReadMessageCount: number;
}
//* 읽지 않은 채팅 수 조회
export const fetchNotReadMessageCount = async () => {
    const url = `${BASE_URL}/not-read-message-count`;
    return await BaseApi.get(url) as fetchNotReadMessageCountResponse;
};

//* 캐스팅 메뉴용 카운트 정보 요청
export interface ICastingMenuCountInfoResponse {
    messageRequestCount: number;
    notReadMessageCount: number;
}
export const fetchCastingMenuCountInfo = async () => {
    const url = `${BASE_URL}/casting`;
    return await BaseApi.get(url) as ICastingMenuCountInfoResponse;
};

//* 허브 메뉴용 카운트 정보 요청
export interface IHubMenuCountInfoResponse {
    newNoticeCount: number;
    newMagazineCount: number;
    newCastingLogCount: number;
}
export const fetchHubMenuCountInfo = async () => {
    const url = `${BASE_URL}/hub`;
    return await BaseApi.get(url) as IHubMenuCountInfoResponse;
};